import styled from "styled-components";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

export const StyledPaper = styled(Paper)`
  width: 100%;
  height: auto;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  padding-right: 10px;
  padding-left: 10px;
  position: sticky;
  top: 20px;
  margin-bottom: 110px;
  box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14), 0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
  @media (max-width: 900px) {
    position: static;
    top: 0;
    margin-bottom: 0px;
    position: relative;
    overflow: hidden;
    height: ${(props) =>
      props.isOpen ? "auto !important" : "310px !important"};
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 5px 0px rgba(0, 0, 0, 0.12) !important;
  }
`;

export const StyledPaperTwo = styled(Paper)`
  display: none;
  @media (max-width: 900px) {
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e9e9e9 !important;
    box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 5px 0px rgba(0, 0, 0, 0.12) !important;
    width: 100%;
    height: auto;
    text-align: center;
    background: #ffffff;
    // border-radius: 8px;
    padding-right: 10px;
    padding-left: 10px;
    margin-bottom: 50px;
    margin-top: 0px;
    padding: 5px;
  }
`;

export const StyledCategoryTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  display: flex;
  justify-contact: end;
  align-items: center;
`;

export const StyledTitleFilteBox = styled.p`
  color: #004a5e;
  padding-top: 20px;
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 15px;
`;

export const StyledTitleBorderDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
`;

export const StyledTitleBorder = styled.div`
  width: 15%;
  border: 2px solid #004a5e;
  border-radius: 5px;
`;

export const StyledCategorieDiv = styled.div`
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  justify-content: right;
  align-items: center;
  color: #4f4f4f;
  transition: 0.1s;
  padding-bottom: 5px;

  &:hover {
    color: #000 !important;
  }
`;

export const StyledCheckbox = styled(Paper)`
  width: 100%;
  height: auto;
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
`;

export const StyledProductsMainDiv = styled(Box)`
  width: 100%;
  height: auto;
  margin-top: 8px;
  text-align: center;
  margin-bottom: 50px;
`;

export const StyledProductsFlex = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
  padding-bottom: 50px;
`;

export const StyledProductDiv = styled(Paper)`
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 4px !important;
  width: 100%;
  padding: 10px;
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 4px;
`;

export const StyledProductImgDiv = styled.div`
  border-radius: 4px;
  width: 225px !important;
  height: 225px !important;
  margin: auto;
  max-width: 100%;
  @media (max-width: 900px) {
    width: 250px !important;
    height: 250px !important;
  }
`;

export const StyledProductImg = styled.img`
  border-radius: 4px;
`;

export const StyledProductTitle = styled.p`
  font-size: 15px;
  font-weight: 300;
  line-height: 2.17;
  color: #41464f;
  height: 52px;
  overflow: hidden;
  text-align: right;
  margin-top: 5px;
`;

export const StyledColorsProduct = styled.div`
  width: 100px;
  height: 19px;
  overflow: hidden;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content:center;
  & > span{
    display:inline-block;
    width:10px;
    height:10px;
    border-radius:100%;
    border 1px solid gray;
    margin:5px;
  }
`;

export const StyledProductPrice = styled.p`
  margin: 0;
  text-align: left;
  color: #41464f;
  font-size: 17px;
  direction: rtl;
`;

export const StyledProductBeforePrice = styled.p`
  margin: 0;
  text-align: left;
  font-size: 17px;
  direction: rtl;
  text-decoration: line-through !important;
  color: #bdc0c4;
`;

export const StyledSlideProductDiscount = styled.div`
  position: absolute;
  width: 42px;
  height: 25px;
  border-radius: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  bottom: 10px;
  right: 10px;
  font-size: 14px;
  background-color: #f1394e !important;
`;
